<template>
    <div :class="[mobileView ? 'poster-div-m' : 'poster-div']">
        <img src="@/assets/ui-challenge/ui-challenge-banner.jpg" :class="[mobileView ? 'banner-m' : 'banner']">
        <div class="heading">
            <header :class="[mobileView ? 'header-m' : 'header']">30 Days of UI Challenge</header>
            <p :class="[mobileView ? 'subheader-posters-m' : 'subheader-posters']">UI/UX Design</p>
        </div>
        <div class="row specs-row" v-if="!mobileView">
            <div class="col l3 offset-l1 m3" >
                <ul class="specs">
                    <li><p class="specs-title">Project Type:</p></li>
                    <li><p class="specs-list">Personal</p></li>
                </ul>
            </div>
            <div class="col l3 offset-l1 m3">
                <ul class="specs">
                    <li><p class="specs-title">Strategies:</p></li>
                    <li><p class="specs-list">Research, UI/UX Design and Graphic Design </p></li>
                </ul>
            </div>
            <div class="col l3 offset-l1 m3">
                <ul class="specs">
                    <li><p class="specs-title">Timeline:</p></li>
                    <li><p class="specs-list">May 2019 - Jan 2022</p></li>
                </ul>
            </div>
            <div class="col l3 offset-l1 m3">
                <ul class="specs">
                    <li><p class="specs-title">Tools Used:</p></li>
                    <li><p class="specs-list">Adobe Illustrator and Figma</p></li>
                </ul>
            </div>
        </div>
        <div v-else class="col s12 col-list">
            <p class="specs-list-m"><text class="specs-title-m">Project Type:</text> Personal</p>
            <p class="specs-list-m"><text class="specs-title-m">Strategies:</text> Research, UI/UX Design and Graphic Design</p>
            <p class="specs-list-m"><text class="specs-title-m">Timeline:</text> May 2019 - Jan 2022</p>
            <p class="specs-list-m"><text class="specs-title-m">Tools used:</text> Adobe Illustrator and Figma</p>
        </div>
        <div :class="[mobileView ? 'overview-m' : 'overview']">
            To build up my ui/ux vocabulary, I challenged myself to design 30 different prompts. I practiced creating designs for both mobile and desktop, with emphasis on simplicity, clarity and coherence. I took the chance to experiment with bold and unique elements, while still keeping functionality in mind.
        </div>
        <section class="posters">
            <poster v-for="poster in posters" :key="poster.title" :poster="poster"></poster>
        </section>
        <div :class="[mobileView ? 'overview-m' : 'overview']">
            To view the entire challenge, check out my <b><a class="link-style" href="https://dribbble.com/arissa/collections/4198970-30-days-of-UI-challenge" target="_blank">dribbble collection</a></b>!
        </div>
        <div class="see-more-div">
            <text :class="[mobileView ? 'sm-title-m' : 'sm-title']">See More Projects</text> 
            <see-more-categories :pageType="category"/>
        </div>
        <contact-me/>
    </div>
</template>

<script>
import Poster from "../components/Poster.vue";
import SeeMoreCategories from "../components/SeeMoreCategories.vue";
import ContactMe from "../components/ContactMe.vue";

export default ({
    name: "ui-challenge",
    components: { Poster, SeeMoreCategories, ContactMe },
    created() {
        window.addEventListener('resize', this.checkScreen);
        this.checkScreen();
        window.addEventListener('scroll', this.reveal);
    },

    data () {
        return {
            mobileView: null,
            windowWidth: null,
            category: "ui-challenge",
            posters: [
                { 
                    title: "Day 01: Sign Up / Login Page, App UI",
                    src: require("@/assets/ui-challenge/day1.svg")
                },
                { 
                    title: "Day 08: Settings, Web UI",
                    src: require("@/assets/ui-challenge/day8.svg")
                }, 
                { 
                    title: "Day 11: Pomodoro Timer, App UI",
                    src: require("@/assets/ui-challenge/day11.svg")
                },  
                { 
                    title: "Day 12: News Article, App UI",
                    src: require("@/assets/ui-challenge/day12.svg")
                },  
                { 
                    title: "Day 15: Ecommerce Item, Web UI",
                    src: require("@/assets/ui-challenge/day15.svg")
                },  
                { 
                    title: "Day 18: Food Delivery, App UI",
                    src: require("@/assets/ui-challenge/day18.svg")
                },  
                { 
                    title: "Day 19: Bus Timing, App UI",
                    src: require("@/assets/ui-challenge/day19.svg")
                },                                                              
            ],
        }
    },

    methods : {
        checkScreen () {
            this.windowWidth = window.innerWidth;
            if (this.windowWidth <= 750){
                this.mobileView= true;
                return;
            }
            this.mobileView = false;
        },

        reveal () {
            var reveals = document.querySelectorAll(".reveal")

            for (var i = 0; i < reveals.length; i++) {
                var windowHeight = window.innerHeight;
                var elementTop = reveals[i].getBoundingClientRect().top;
                var elementVisible = 150;

                if (elementTop < windowHeight - elementVisible) {
                    reveals[i].classList.add("active");
                } else {
                    reveals[i].classList.remove("active");
}
            }           
        },
    }
})
</script>

<style scoped>
.banner {
    margin-top: 20px;
    width: 100%;
}


a {
    color: #EA4C89;
}

a:hover {
    color: #ED9DC1;
}

.link-style {
    text-underline-offset: 2px;
    text-decoration-color: #F7C760;
    text-decoration-thickness: 3px;
}
</style>